import { useCasePhotoUrl } from '@/application/usecases/useKits';
import { initials } from '@/shared/format/initials';
import styles from './Avatar.module.css';

/**
 * A person's photograph, or their initials when there is none or it has not
 * loaded. The photograph is fetched with the access token, as a case photograph
 * is, because a browser puts none on an image request.
 */
export function Avatar({ name, url, size = 40 }: { name: string; url: string | null | undefined; size?: number }) {
  const src = useCasePhotoUrl(url ?? undefined);
  return (
    <span className={styles.avatar} style={{ width: size, height: size, fontSize: Math.round(size * 0.38) }} aria-hidden="true">
      {src === null ? initials(name) : <img src={src} alt="" />}
    </span>
  );
}
